import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { css } from "styled-components";

productQuantityOrderedStyles.cssOverrides = {
    inputSelect: css`
        height: 40px;
        background-color: #fff !important;
    `,
    formInputWrapper: css`
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    `,
};
